/**
 * @name DownloadMacro
 * @description Componente para descargar el archivo con la macro de Excel
 * @author Ricardo Guerra
 */

import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import styled from 'styled-components';

import { Environment } from '@config';
import { Flex, MUI, Unicons, Typography } from '@styles';

const DownloadMacro = ({ URL }) => {
  // Genera la URL de donde se debe descargar la macro acorde al ambiente del que consulta el usuario
  const getMacroURL = (URL) => {
    let environmentName = parseInt(Environment.getCurrent().environmentId) > 1 && parseInt(Environment.getCurrent().environmentId) < 6 ? Environment.getCurrent().name : 'test';
    return `https://s3-us-west-1.amazonaws.com/ty-assets/macros/${environmentName}/${URL}`;
  };

  return (
    <Styled.ButtonLink href={getMacroURL(URL)}>
      <Flex.Col alignItems="center" justifyContent="center">
        <Unicons.Download style={{ marginBottom: '4px' }} />
        <Typography.Text color="blueDark">{i18n.t('MassiveUploads.downloadBaseFile')}</Typography.Text>
        <Typography.Text color="greyDarkAlpha">
          {`${i18n.t('UploadFile.format')}: `}
          <Typography.Small>{'XLSM'}</Typography.Small>
        </Typography.Text>
      </Flex.Col>
    </Styled.ButtonLink>
  );
};

DownloadMacro.propTypes = {
  // URL del archivo macro de Excel.
  URL: PropTypes.string.isRequired
};

// *************************************
// STYLED COMPONENTS
// *************************************

const Styled = {};

Styled.ButtonLink = styled(MUI.ButtonLink)`
  &.MuiButton-root {
    min-height: auto;
    min-width: auto;
    width: fit-content;
    padding: 8px;
  } 
`;

export default DownloadMacro;